import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class NormalizeService {

  constructor() { }

  normalize(text: string): string {
    return text?.toLowerCase()
      .replace(/ı/g, 'i')
      .replace(/İ/g, 'i')
      .replace(/ç/g, 'c')
      .replace(/ğ/g, 'g')
      .replace(/ö/g, 'o')
      .replace(/ş/g, 's')
      .replace(/ü/g, 'u')
      .replace(/[^a-z0-9]/g, '')  // boşluk, noktalama kaldırılıyor
      .trim();
  }
}
